export default {
  status_client: [],
  clients: {
    results: [],
  },
  client: {
    emails: {},
    phones: {},
    sphere_of_activity: {},
  },
  contracts: {
    results: [],
  },
  comments: {
    results: [],
  },
  users: {
    results: [],
  },
  sphere_of_activity: {
    results: [],
  },
  targets: {
    results: [],
  },
  attachments: {
    results: [],
  },
  client_groups: {
    results: [],
  },
  client_payment_types: {
    results: [],
  },
  client_interested: {
    results: [],
  },
  client_requests: {
    results: [],
  },
  single_employee: {},
  payment_installments: [
    {
      contract_number: "16513541651",
      total_price: 1213512135132,
      payments: [],
    },
  ],
  employee: {
    results: [],
  },
};
